import React from 'react'
import {Redirect, Route} from "react-router-dom";

const PrizeUnlockAdd = loadable(() => import('./activity/prizeunlock_add'));
const PrizeUnlockOrderDetail = loadable(() => import('./prize_order/orderDetail'));
const PrizeUnlockManage = loadable(() => import('./prizeunlock_manage'));
import loadable from "../../loadable";

class MarketPrizeUnlock extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <Route exact path={this.props.match.url + '/'}
                       render={() => (<Redirect to={this.props.match.url + "/manage/activity"}/>)}
                />
                <Route path={this.props.match.url + "/manage/:id"} component={PrizeUnlockManage}/>
                <Route path={this.props.match.url + "/activity/create"} render={(props) => {
                    props['type'] = 'create';
                    return <PrizeUnlockAdd {...props}/>
                }}/>
                <Route path={this.props.match.url + "/activity/edit/:id"} render={(props) => {
                    props['type'] = 'edit';
                    return <PrizeUnlockAdd {...props}/>
                }}/>
                <Route path={this.props.match.url + "/activity/copy/:id"} render={(props) => {
                    props['type'] = 'copy';
                    return <PrizeUnlockAdd {...props}/>
                }}/>
                <Route path={this.props.match.url + "/order/detail/:id"} component={PrizeUnlockOrderDetail}/>
            </>
        )
    }
}

export default MarketPrizeUnlock